import { HotelViewEnum } from "@controllers/customHooks/useHotelView";

export const ViewTypeLabel = {
  [HotelViewEnum.ListView]: 'List View',
  [HotelViewEnum.MapView]: 'Map View'
};

